import { IInitialBrandsState } from 'interfaces/brands.interface';
import * as BrandsTypes from './brands.types';
import { IgetBrandsAPIResponseDataItem } from 'api/endpoints/myBrands/myBrands.response.interface';

export type TbrandsDispatchReducer =
  | {
      type: typeof BrandsTypes.GET_PAGINATION_BRANDS;
      payload: Array<IgetBrandsAPIResponseDataItem>;
    }
  | {
      type: typeof BrandsTypes.GET_ALL_BRANDS;
      payload: Array<IgetBrandsAPIResponseDataItem>;
    }
  | {
      type: typeof BrandsTypes.ADD_MORE_BRANDS;
      payload: Array<IgetBrandsAPIResponseDataItem>;
    }
  | {
      type: typeof BrandsTypes.SET_THERE_ARE_MORE_BRANDS;
      payload: boolean;
    }
  | {
      type: typeof BrandsTypes.SET_IS_LOADING_GET_ALL_BRANDS;
      payload: boolean;
    }
  | {
      type: typeof BrandsTypes.SET_IS_LOADING_GET_PAGINATION_BRANDS;
      payload: boolean;
    }
  | {
      type: typeof BrandsTypes.SET_BODY_SEARCH;
      payload: string | null;
    }
  | {
      type: typeof BrandsTypes.RESET_BODY_SEARCH;
      payload?: null;
    };

export default function brandsReducer(
  state: IInitialBrandsState,
  action: TbrandsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case BrandsTypes.GET_PAGINATION_BRANDS:
      const getPaginationBrands: IInitialBrandsState = {
        ...state,
        brandsWithPagination: payload,
        bodyFetch: {
          ...state.bodyFetch,
          index: payload.length,
        },
      };
      return getPaginationBrands;

    case BrandsTypes.GET_ALL_BRANDS:
      const getAllBrands: IInitialBrandsState = {
        ...state,
        allBrands: payload,
      };
      return getAllBrands;

    case BrandsTypes.ADD_MORE_BRANDS:
      const addMoreBrands: IInitialBrandsState = {
        ...state,
        brandsWithPagination: state.brandsWithPagination.concat(payload),
        bodyFetch: {
          ...state.bodyFetch,
          index: state.bodyFetch.index + payload.length,
        },
      };
      return addMoreBrands;

    case BrandsTypes.SET_THERE_ARE_MORE_BRANDS:
      const setThereAreMoreBrands: IInitialBrandsState = {
        ...state,
        thereAreMoreBrands: payload,
      };
      return setThereAreMoreBrands;

    case BrandsTypes.SET_IS_LOADING_GET_PAGINATION_BRANDS:
      const setIsLoadingGetMoreBrands: IInitialBrandsState = {
        ...state,
        isLoadingGetPaginationBrands: payload,
      };
      return setIsLoadingGetMoreBrands;

    case BrandsTypes.SET_BODY_SEARCH:
      const setBodySearch: IInitialBrandsState = {
        ...state,
        bodyFetch: {
          ...state.bodyFetch,
          search: payload,
        },
      };
      return setBodySearch;

    case BrandsTypes.RESET_BODY_SEARCH:
      const resetBodySearch: IInitialBrandsState = {
        ...state,
        bodyFetch: {
          ...state.bodyFetch,
          search: '',
        },
      };
      return resetBodySearch;

    case BrandsTypes.SET_IS_LOADING_GET_ALL_BRANDS:
      const setIsLoading: IInitialBrandsState = {
        ...state,
        isLoadingGetAllBrands: payload,
      };
      return setIsLoading;

    default:
      return state;
  }
}
